<template>
  <QPage
    padding
    class="bg-background"
  >
    <div class="q-mx-auto stl-content-container stl-content-container--small">
      <div class="text-center">
        <AppContent
          tag="h4"
          class="text-h4"
          path="pages.stories.title"
        />
        <AppContent
          tag="h6"
          class="text-h6"
          path="pages.stories.subtitle"
        />
        <AppContent
          class="text-body2"
          path="pages.stories.incitation"
          :options="{ nbStories }"
        />
        <QBtn
          color="primary"
          class="q-mt-sm"
          :label="$t({ id: 'pages.stories.add_title' })"
          @click="showDialog = true"
        />
      </div>

      <QSeparator class="q-my-md" />

      <QCard
        v-for="(s, index) in stories"
        :key="index"
        class="q-mt-md"
      >
        <QCardSection class="text-body1">
          {{ s.description }}
          <AppContent
            path="pages.stories.by"
            :options="{ author: s.metadata.anonymous ? $t({ id: 'pages.stories.anon' }) : s.name, datetime: $t({ id: 'time.datetime' }, { fmtd: s.createdDate }) }"
            class="text-caption text-primary text-right"
          />
        </QCardSection>
      </QCard>

      <div
        v-if="stories.length < nbStories"
        class="flex flex-center q-mt-xl"
      >
        <HCButton
          icon="uil:sync"
          label="pages.blog.load_more"
          @click="page++; refresh()"
        />
      </div>

      <QDialog
        v-model="showDialog"
        :maximized="$q.screen.lt.sm"
        @hide="showDialog = false"
      >
        <QCard>
          <QCardSection class="q-pb-none">
            <AppContent
              class="text-h6"
              path="pages.stories.add_title"
            />
          </QCardSection>
          <QCardSection>
            <div class="flex column q-gutter-y-md">
              <QForm
                v-if="!created"
                @submit="createStory"
              >
                <AppContent
                  class="text-body1 q-mb-md"
                  path="pages.stories.add_subtitle"
                />
                <QInput
                  v-model="story.name"
                  :label="$t({ id: 'pages.stories.add_firstname' })"
                  class="col-6"
                  :rules="[val => !!val || $t({ id: 'form.error.missing_field' })]"
                  outlined
                />
                <QInput
                  v-model="story.description"
                  autogrow
                  type="textarea"
                  :label="$t({ id: 'pages.stories.add_story' })"
                  :rules="[val => !!val || $t({ id: 'form.error.missing_field' })]"
                  outlined
                />
                <div class="flex justify-between">
                  <QCheckbox
                    v-model="story.metadata.anonymous"
                    :label="$t({ id: 'pages.stories.add_anonymous' })"
                  />
                  <QBtn
                    color="primary"
                    :label="$t({ id: 'prompt.send_button' })"
                    type="submit"
                  />
                </div>
              </QForm>
              <div
                v-else
                class="flex column justify-center text-center q-gutter-y-sm"
              >
                <AppContent
                  class="text-body1"
                  path="pages.stories.add_thanks"
                />
                <QBtn
                  flat
                  unelevated
                  color="primary"
                  label="Fermer"
                  @click="showDialog = false"
                />
              </div>
            </div>
          </QCardSection>
        </QCard>
      </QDialog>
    </div>
  </QPage>
</template>

<script>
import { remapToPaginated } from 'hc-core/composables/misc'

export default {
  data () {
    return {
      stories: [],
      created: false,
      showDialog: false,
      page: 1,
      nbStories: 0,
      story: {
        active: false,
        metadata: {
          anonymous: false
        }
      }
    }
  },
  computed: {
    vdcStoriesTypeId () { return this.$_.get(this.$store, 'state.common.config.custom.assetTypeIds.vdcStory', false) }
  },
  async mounted () {
    await this.refresh()
  },
  methods: {
    async refresh () {
      try {
        const storiesRequest = remapToPaginated(await this.$store.dispatch('asset/list', { assetTypeId: this.vdcStoriesTypeId, active: true, orderBy: 'createdDate', order: 'desc', nbResultsPerPage: 20, page: this.page }))
        this.nbStories = storiesRequest.nbResults
        this.stories = this.$_.union(
          this.stories,
          this.$_.get(storiesRequest, 'results', [])
        )
      } catch (e) { this.useLogger(e) }
    },
    async createStory () {
      try {
        this.$_.set(this.story, 'assetTypeId', this.vdcStoriesTypeId)
        await this.$store.dispatch('asset/create', { asset: this.story })
        this.created = true
        this.story = { active: false, metadata: { anonymous: false } }
      } catch (e) { this.useLogger(e) }
    },
  }
}
</script>
